import { api } from './http';

/**
 * The one bulk endpoint every list screen uses. `path` is the console API
 * family — "/articles", "/members" — and the server mounts `${path}/bulk`
 * under that family's own permission.
 */
export const bulk = {
  bulk: (path: string, action: string, ids: number[]) =>
    api.post<{ ok: true; changed: number }>(`${path}/bulk`, { action, ids }),
};
